import hash from 'object-hash';

// refer to www.npmjs.com/package/object-hash for options values
export const generateHash = (val, options = {})=>
  hash(val, options);
